import React from 'react';

const TypingIndicator = ({ otherUser }) => {
  return (
    <div className="flex items-center space-x-2 text-gray-500 text-sm mb-4">
      <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden flex-shrink-0">
        {otherUser?.profile_image ? (
          <img src={otherUser.profile_image} alt={otherUser.name} className="w-full h-full object-cover" />
        ) : (
           <span className="text-xs">{otherUser?.name?.charAt(0).toUpperCase()}</span>
        )}
      </div>
      <div className="bg-gray-100 px-3 py-2 rounded-2xl rounded-bl-sm flex space-x-1.5 items-center">
        <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce"></div>
      </div>
    </div>
  );
};

export default TypingIndicator;
